import { render, staticRenderFns } from "./TabsHead.vue?vue&type=template&id=55c96e7e&"
import script from "./TabsHead.vue?vue&type=script&lang=js&"
export * from "./TabsHead.vue?vue&type=script&lang=js&"
import style0 from "./TabsHead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports